module.exports = __webpack_public_path__ + "img/f6-02.e8880ad2.png";